<template>
  <div class="nettdoc-raised-body-temperature">
    <SectionHeader 
      text="I do have a fever" 
      img="illu-card-beschwerden-fever" 
      alt="fever" 
      :collapsable="true" 
      v-on:collapse="collapsed = !collapsed"
      :complete="store.raisedBodyTemperatureDetails.submitted"
    />

    <template v-if="collapsed">
      <SectionHeader text="Since when do you have a fever?" :dark="true" :required="true" />
      <Dropdown
        label="please choose"
        :data="['Few hours', '1 day', '2 to 6 days', 'More than one week', '1 month']"
        :choice="store.raisedBodyTemperatureDetails.since"
        v-on:action="value => store.addRaisedBodyTemperatureDetails('since', value)"
      />

      <SectionHeader text="measured" :dark="true" :required="false" />
      <YesNo
        :model="store.raisedBodyTemperatureDetails.measured"
        v-on:action="value => store.addRaisedBodyTemperatureDetails('measured', value)"
      />
      
      <template v-if="store.raisedBodyTemperatureDetails.measured === 'yes'">
        <SectionHeader text="measuredValueInDegrees" :dark="true" :required="false" />
        <NumberInput
          label="°C"
          :showLabel="true"
          :model="store.raisedBodyTemperatureDetails.measuredValueInDegrees"
          v-on:action="value => store.addRaisedBodyTemperatureDetails('measuredValueInDegrees', value)"
        />
      </template>

      <SectionHeader text="growingPain" :dark="true" :required="false" />
      <YesNo
        :model="store.raisedBodyTemperatureDetails.growingPain"
        v-on:action="value => store.addRaisedBodyTemperatureDetails('growingPain', value)"
      />

      <SectionHeader text="cough" :dark="true" :required="true" />
      <YesNo
        :model="store.raisedBodyTemperatureDetails.cough"
        v-on:action="value => store.addRaisedBodyTemperatureDetails('cough', value)"
      />

      <template v-if="store.raisedBodyTemperatureDetails.cough === 'yes'">
        <SectionHeader text="coughWithoutBloodyAdditives" :dark="true" :required="false" />
        <YesNo
          :model="store.raisedBodyTemperatureDetails.coughWithoutBloodyAdditives"
          v-on:action="value => store.addRaisedBodyTemperatureDetails('coughWithoutBloodyAdditives', value)"
        />
      </template>

      <SectionHeader text="throatHurts" :dark="true" :required="false" />
      <YesNo
        :model="store.raisedBodyTemperatureDetails.throatHurts"
        v-on:action="value => store.addRaisedBodyTemperatureDetails('throatHurts', value)"
      />

      <SectionHeader text="cold" :dark="true" :required="false" />
      <YesNo
        :model="store.raisedBodyTemperatureDetails.cold"
        v-on:action="value => store.addRaisedBodyTemperatureDetails('cold', value)"
      />

      <SectionHeader text="earsHurt" :dark="true" :required="false" />
      <YesNo
        :model="store.raisedBodyTemperatureDetails.earsHurt"
        v-on:action="value => store.addRaisedBodyTemperatureDetails('earsHurt', value)"
      />

      <SectionHeader text="nearSurroundingSick" :dark="true" :required="true" />
      <TripleChoice
        :model="store.raisedBodyTemperatureDetails.nearSurroundingSick"
        v-on:action="value => store.addRaisedBodyTemperatureDetails('nearSurroundingSick', value)"
      />

      <SectionHeader text="painUrinating" :dark="true" :required="true" />
      <YesNo
        :model="store.raisedBodyTemperatureDetails.painUrinating"
        v-on:action="value => store.addRaisedBodyTemperatureDetails('painUrinating', value)"
      />

      <SectionHeader text="rash" :dark="true" :required="false" />
      <YesNo
        :model="store.raisedBodyTemperatureDetails.rash"
        v-on:action="value => store.addRaisedBodyTemperatureDetails('rash', value)"
      />

      <SectionHeader text="stomachAche" :dark="true" :required="false" />
      <YesNo
        :model="store.raisedBodyTemperatureDetails.stomachAche"
        v-on:action="value => store.addRaisedBodyTemperatureDetails('stomachAche', value)"
      />

      <Button :text="edit ? 'Update' : 'Submit'" v-on:action="submit" :active="store.raisedBodyTemperatureDetailsComplete" />
    </template>

  </div>
</template>

<script>
import { observer } from "mobx-vue";

import SectionHeader from "../SectionHeader";
import YesNo from "../YesNo";
import Button from "../Button";
import Dropdown from "../Dropdown";
import NumberInput from "../NumberInput";
import TripleChoice from "../TripleChoice";
export default observer({
  name: "RaisedBodyTemperature",
  data() {
    return {
      collapsed: true
    };
  },
  props: {
    store: Object,
    edit: Boolean
  },
  components: {
    SectionHeader, YesNo, Button, Dropdown, NumberInput, TripleChoice
  },
  methods: {
    submit: function() {
      this.store.raisedBodyTemperatureDetails.submitted = true
      localStorage.setItem(
        "raisedBodyTemperatureDetails",
        JSON.stringify(this.store.raisedBodyTemperatureDetails)
      )
      if (this.edit) {
        this.$emit('close')
      } else {
        this.collapsed = !this.collapsed
        window.scrollTo(0,0)
      }
    }
  }
})
</script>

<style>

</style>